<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:20px;">
  <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 20px;">Εισάγετε τον κωδικό</div>
<!--  <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 12px; margin-top:20px; white-space: normal; width:350px;">{{authStepMessage}}</div>-->
  <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">

    <mat-form-field>
      <label>
        <input matInput formControlName="secondCtrl" [(ngModel)]="secretCode" maxlength="6" minlength="6" required placeholder="Κωδικός">
      </label>
    </mat-form-field>

  </div>
</div>
